import styled from 'styled-components';
const Toggle = styled.span`
  top: ${props => `${props.top || 0}px`};
  left: ${props => `${props.left || 0}px`};
  z-index: 10;
  width: ${props => {
  var _props$styleOptions, _props$styleOptions2;

  return typeof ((_props$styleOptions = props.styleOptions) === null || _props$styleOptions === void 0 ? void 0 : _props$styleOptions.width) !== undefined ? `${(_props$styleOptions2 = props.styleOptions) === null || _props$styleOptions2 === void 0 ? void 0 : _props$styleOptions2.width}px` : 'auto';
}};
  background-color: ${props => {
  var _props$styleOptions3;

  return (_props$styleOptions3 = props.styleOptions) === null || _props$styleOptions3 === void 0 ? void 0 : _props$styleOptions3.backgroundColor;
}};
  color: ${props => {
  var _props$styleOptions4;

  return (_props$styleOptions4 = props.styleOptions) === null || _props$styleOptions4 === void 0 ? void 0 : _props$styleOptions4.textColor;
}};
  &.top::before {
    border-top-color: ${props => {
  var _props$styleOptions5;

  return (_props$styleOptions5 = props.styleOptions) === null || _props$styleOptions5 === void 0 ? void 0 : _props$styleOptions5.backgroundColor;
}};
  }
  &.right::before {
    border-right-color: ${props => {
  var _props$styleOptions6;

  return (_props$styleOptions6 = props.styleOptions) === null || _props$styleOptions6 === void 0 ? void 0 : _props$styleOptions6.backgroundColor;
}};
  }
  &.bottom::before {
    border-bottom-color: ${props => {
  var _props$styleOptions7;

  return (_props$styleOptions7 = props.styleOptions) === null || _props$styleOptions7 === void 0 ? void 0 : _props$styleOptions7.backgroundColor;
}};
  }
  &.left::before {
    border-left-color: ${props => {
  var _props$styleOptions8;

  return (_props$styleOptions8 = props.styleOptions) === null || _props$styleOptions8 === void 0 ? void 0 : _props$styleOptions8.backgroundColor;
}};
  }
`;
export default Toggle;